import { render, staticRenderFns } from "./Expunerea.vue?vue&type=template&id=272c573c&scoped=true&"
import script from "./Expunerea.vue?vue&type=script&lang=js&"
export * from "./Expunerea.vue?vue&type=script&lang=js&"
import style0 from "./Expunerea.vue?vue&type=style&index=0&id=272c573c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c573c",
  null
  
)

export default component.exports